<div class="taskboardview">
    <app-branding-header-bar></app-branding-header-bar>
    <app-informationview [viewName]="'taskboardview'"></app-informationview>

    <!-- Column-Headings -->
    <div *ngIf="this.boardConfiguration" class="daily__row daily__row--header">
        <div class="daily__cardcontainer">
            <div *ngFor="let column of boardConfiguration.columns"
                 class="daily__cell daily__cell--header"
                 [ngClass]="{'empty-column' : (column.isEmpty)}">
                {{column.name}}
            </div>
        </div>
        <div class="daily__header-buttons" *ngIf="this.selectedSprint.state !== 'closed'">
            <a class="daily__add-issue" (click)="openNewIssueDialog($event)">
                {{('actionview.taskboard.addIssue' | translate)}}
            </a>
            <a class="daily__mark-all-read" (click)="markAllAsRead()">
                Mark all as read
            </a>
        </div>
    </div>

    <div id="actionview" class="actionview">
        <div id="daily-main-container">

            <div *ngFor="let rowData of taskboardData" cdkDropListGroup
                [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}"
                class="daily__row" id="story-id-{{rowData.userstory.id}}">

                <div class="daily__cardcontainer">

                <!-- Column for every Column in BoardConfiguration -->
                <div *ngFor="let column of rowData.columns" cdkDropList class="daily__cell issue-list board-column"
                    [cdkDropListData]="column"
                    (cdkDropListDropped)="onIssueDropped($event)"
                    [ngClass]="{'empty-column' : (column.isEmpty)}"
                    [attr.data-issueid]="rowData.userstory.id"
                    [attr.data-columnname]="column.name"
                    [attr.data-columnid]="column.id"
                    [attr.data-columntype]="column.type"
                >

                    <app-issue *ngFor="let issue of column.issues"
                        class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone"
                        cdkDrag
                        [ngClass]="{
                            'parent-issue': (!issue.isSubissue),
                            'sub-issue':(issue.isSubissue)
                        }"
                        [issue]="issue"
                        [projectKey]="selectedProjectKey"
                        [statuses]="columnStatuses"
                        [inheritedIssueType]="rowData.userstory.issueType"
                        [attr.data-issueid]="issue.id"
                        [attr.data-projectkey]="selectedProjectKey"
                        [attr.data-highlightcolor]="issue.highlightColor"
                        [cdkDragData]="issue"
                        (cdkDragMoved)="onCardMoved($event)"
                        (issueRemoved)="removeParentIssue($event)"
                        (subIssueRemoved)="removeSubissue($event)"
                        (issuecardClosed)="onCardClosedByIssue($event)"
                        (issueModified)="onIssueModified(issue)"
                    >
                    </app-issue>

                  </div>
              </div>
                <a class="daily__add-subissue" (click)="openNewSubissueDialog(rowData.userstory.id, $event)">
                    {{('actionview.taskboard.addSubissue' | translate)}}
                </a>
            </div>
        </div>
        <!-- This container is used to mock dragging card previews for sync-clients -->
        <div id="syncPreviewContainer"></div>
    </div> <!-- actionview closing div-->
    <app-footerbar></app-footerbar>
</div>

<div id="popupContainer">
    <ng-template #popupInsertionPoint></ng-template>
</div>
